module.exports = __webpack_public_path__ + "img/agenttracker-agentdetail.b7feae70.png";